import React from 'react';
import PropTypes from 'prop-types';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const BlogCard = ({ heading, image, link }) => {
  return (
    <div className="w-full h-auto rounded-xl overflow-hidden shadow-md bg-white mx-auto group hover:shadow-lg cursor-pointer">
      <img
        className="w-full h-56 my-4 cursor-pointer rounded-t-xl"
        src={image}
        alt={heading}
      />
      <div className="px-6 py-4">
        <div className="font-semibold text-lg mb-4 hover:text-emerald-600 cursor-pointer">
          {heading}
        </div>
        <Link
          to={link}
          onClick={() => window.scrollTo(0, 0)}
          className="font-semibold focus:outline-none group-hover:text-emerald-600 py-2"
        >
          Read More <FontAwesomeIcon icon={faPlus} className="flex-shrink-0 w-4 h-4 transition-transform duration-300 transform group-hover:rotate-90" />
        </Link>
        
      </div>
    </div>
  );
};

BlogCard.propTypes = {
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default BlogCard;
